import RequestStatus from "../model/RequestStatus";
import {ProgramFees, ProgramParam} from "../model/ProgramFees";
import QueryProductInfo from "src/model/QueryProduct";

export const PROGRAM_FEES_QUERY_START = 'PROGRAM_FEES_QUERY_START';
export const ADDITIONAL_PROGRAM_FEES_QUERY_START = 'ADDITIONAL_PROGRAM_FEES_QUERY_START';
export const UPDATE_PROGRAM_FEES_QUERY_START = 'UPDATE_PROGRAM_FEES_QUERY_START';
export const PROGRAM_FEES_QUERY_SUCCESS = 'PROGRAM_FEES_QUERY_SUCCESS';
export const PROGRAM_FEES_QUERY_FAILED = 'PROGRAM_FEES_QUERY_FAILED';

export interface ProgramFeesQueryStartAction {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly countryCode: string;
    readonly queryProduct: QueryProductInfo;
    readonly programIdList: Array<string>;
    readonly programParamMap?: Record<string, ProgramParam>;
}

export const setProgramFeesQueryStart = (countryCode: string, queryProduct: QueryProductInfo, programIdList: Array<string>): ProgramFeesQueryStartAction => ({
    type: PROGRAM_FEES_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: countryCode,
    queryProduct: queryProduct,
    programIdList: programIdList
});

export const setAdditionalProgramFeesQueryStart = (countryCode: string, queryProduct: QueryProductInfo, programIdList: Array<string>, programParamMap?: Record<string, ProgramParam>): ProgramFeesQueryStartAction => ({
    type: ADDITIONAL_PROGRAM_FEES_QUERY_START,
    requestStatus: RequestStatus.LOADING,
    countryCode: countryCode,
    queryProduct: queryProduct,
    programIdList: programIdList,
    programParamMap: programParamMap
});

export const setUpdateProgramFeesQueryStart = (countryCode: string, queryProduct: QueryProductInfo, programIdList: Array<string>, programParamMap?: Record<string, ProgramParam>): ProgramFeesQueryStartAction => ({
    type: UPDATE_PROGRAM_FEES_QUERY_START,
    requestStatus: RequestStatus.UPDATING,
    countryCode: countryCode,
    queryProduct: queryProduct,
    programIdList: programIdList,
    programParamMap: programParamMap
});

export interface GetProgramFeesQueryComplete {
    readonly type: string;
    readonly requestStatus: RequestStatus;
    readonly programFees: any;
    readonly programIdList: Array<string>;
}

export const getProgramFeesQuerySuccessAction = (programIdList: Array<string>, programFees: ProgramFees): GetProgramFeesQueryComplete => ({
    type: PROGRAM_FEES_QUERY_SUCCESS,
    requestStatus: RequestStatus.SUCCESS,
    programIdList: programIdList,
    programFees: programFees,
});

export const getProgramFeesQueryFailedAction = (programIdList: Array<string>): GetProgramFeesQueryComplete => ({
    type: PROGRAM_FEES_QUERY_FAILED,
    requestStatus: RequestStatus.ERROR,
    programIdList: programIdList,
    programFees: null
});
